<div class="dialog-form">
        <div class="form-group">
            <div class="form-control">
                <label for="boat">Embarcação</label>
                <p-dropdown
                    [options]="boats"
                    [(ngModel)]="selectedBoat"
                    optionLabel="name"
                    [filter]="true"
                    filterBy="name"
                    placeholder="Selecione uma embarcação"
                    emptyMessage="Nenhuma embarcação ativa sem vaga"
                    inputId="boat"
                    name="boat"
                    appendTo="body"
                    [style]="{'width':'100%'}"
                >
                    <ng-template pTemplate="item" let-boat>
                        {{boat.name}} - {{boat.shipyardName}}:{{boat.shipyardModelName}} ({{boat.comercialLength}}")
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
        <div class="form-group align-center">
            <div class="buttons">
                <button type="button" class="easymarine danger" (click)="onCancel()">{{ 'CANCEL' | translate }}</button>
                <button type="button" class="easymarine primary" (click)="onConfirm()" [disabled]="!selectedBoat">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
</div>
